import React, { Component } from 'react'
import DiscountSection from '../../components/DiscountSection/DiscountSection'
import Header from '../../components/Header/Header'
import HomeHero from '../../components/HomeHero/HomeHero'
import PersonSection from '../../components/PersonSection/PersonSection'
import SliderSection from '../../components/SliderSection/SliderSection'
import LoadingScreen from '../../components/Loading/Loading'
import axios from "axios";
import TrendingBrand from '../../components/TrendingBrand/TrendingBrand'
import bk from "../../assets/bk.svg"
import Footer from '../../components/Footer/Footer'
import { addItemsList } from '../../redux/products/products.action'
import { fetchCart } from "../../network/product.network";
import { connect } from 'react-redux'
import { fetchHome } from '../../network/home.network' 
import localization from '../../Localization/Localization.json'
import { addProductToCart, clearCart } from '../../redux/cart/cart.action'
import { setAddressUser, setPaymentUser } from '../../redux/user/user.action'
import ResNavBar from '../../components/ResNavBar/ResNavBar'
import OffterSection from '../../components/OffterSection/OffterSection'
// import { useQuery } from "react-query";

// function Query(props) {
//   return props.children(useQuery(props.keyName, props.fn, props.options));
// }
class Home extends Component {
    state = {
        cosmeticsList: [],
        trendList: [],
        discoundList: [], 
        home_details : null,
        loading : true
      };
    componentDidMount() {
      // console.log(this.props.productsList.length) 
      // if(this.props.productsList.length === 0){  
      //   axios
      //     .get("https://makeup-api.herokuapp.com/api/v1/products.json")
      //     .then((res) => {
      //         const list = res.data;
      //         this.setState({ cosmeticsList : list.slice(20, 28), discoundList :  list.slice(0, 8)});  
      //         this.props.dispatch(addItemsList(list))
      //     }); 
      // }else{
      //   this.setState({
      //     cosmeticsList : this.props.productsList.slice(20, 28),  
      //     discoundList :  this.props.productsList.slice(0, 8),
      //     trendList :  this.props.productsList.slice(122, 125),
      //   })  
      // }
      

        // axios
        //   .get("https://fakestoreapi.com/products")
        //   .then((res) => {
        //       console.log(res)
        //     this.setState({ trendList : res.data }); 
        //   }); 

          fetchHome((res) => { 
            console.log(res) 
            // if(res.data.code === 200) { 
            // }
            this.setState({home_details : res.data.data, loading : false})
            this.props.dispatch(setAddressUser(res.data.data.address)) 
            this.props.dispatch(setPaymentUser(res.data.data.paymentType)) 
           
          }, (error) => { 
            this.setState({loading : false})
            console.log(error)
          })
          
          // if(this.props.currentUser){ 
            fetchCart((res) => {
              this.props.dispatch(clearCart());
              setTimeout(() => { 
                res.data.data?.cart?.items?.forEach(ele => {  
                const isProductExistInStorage = this.props.cartItems?.some(
                  (product) => +product.id === +ele.productId
                );
                console.log(isProductExistInStorage); 
                if (!isProductExistInStorage) {
                  this.props.dispatch(addProductToCart({ ...ele, 
                    productId : +ele.id,
                    id : +ele.productId,
                    inCart: {  
                      itemId: +ele.id,  
                      quantity: +ele.quantity,
                    },
                   }));
                }
              })
              }, 300) 
              
              // res.data.data.cart.items.forEach(ele => {
              //   const isProductExistInStorage = cartItems?.some(
              //     (product) => +product.id === +ele.productId
              //   );
              //   if (!isProductExistInStorage) {
              //     this.props.dispatch(addProductToCart({ ...ele, 
              //       productId : +ele.id,
              //       id : +ele.productId,
              //       inCart: {  
              //         itemId: +ele.id,   
              //         quantity: +ele.quantity,
              //       },
              //      }));
              //   }
              // })
            }, (error) => {
              console.log(error) 
            })
          // }
      } 
 
    render() { 
        const { cosmeticsList, trendList, discoundList, home_details, loading } = this.state;
        const { currentLang } = this.props;
        return (
            <div className="page-content-wrapper home-wrapper">
              {loading ? <LoadingScreen /> : 
                <>
                  <Header />
                  <div className="bg-wrapper"> 
                  <HomeHero data={home_details?.slider} />
                  <PersonSection data={home_details?.category} /> 
                  <TrendingBrand title={localization.trendingbrands[currentLang]} data={home_details?.brands} />
                  <SliderSection title={localization.TrendProducts[currentLang]} sliderList={home_details?.products || []} />
                  <OffterSection title={localization.Bestoffers[currentLang]} data={home_details?.offerTypes || []} /> 
                  {/* <SliderSection title="20% products" bk={bk} sliderList={cosmeticsList} />  */}
                  <DiscountSection title={localization.Discount[currentLang]} discoundList={home_details?.discountProducts || []} />  
                  {/* <SliderSection title="Cosmetics" sliderList={cosmeticsList} />  */}
                  </div>
                  <Footer /> 
                  <ResNavBar />  
                </>
              }
            </div>
            )
    }
}

const mapStateToProps = (state) => ({
  productsList : state.products.productsList,
  currentLang : state.user.currentLang,
  currentUser : state.user.currentUser,
  cartItems: state.cart.cartItems,
})

export default connect(mapStateToProps)(Home); 

